var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import { theme, IconMilesInput, MessageBanner, H3 } from '@by-miles/bymiles-styles';
import { MilesInputStyle } from './MilesInputStyle';
export var QQMilesInput = function (_a) {
    var onChange = _a.onChange, onBlur = _a.onBlur, _b = _a.showBanner, showBanner = _b === void 0 ? false : _b, bannerText = _a.bannerText, className = _a.className, milesInputState = _a.milesInputState, isQQPage = _a.isQQPage;
    var inputRef = useRef(null);
    var inputWrapperRef = useRef(null);
    var _c = useState((milesInputState === null || milesInputState === void 0 ? void 0 : milesInputState.estimated_mileage) > 0
        ? milesInputState === null || milesInputState === void 0 ? void 0 : milesInputState.estimated_mileage.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        : '0'), value = _c[0], setValue = _c[1];
    useEffect(function () {
        var element = inputRef.current;
        if (element) {
            element.addEventListener('keypress', function (e) {
                if (e.key === 'Enter')
                    this.blur();
            });
        }
    }, []);
    function handleInputChange(event) {
        var _a, _b, _c;
        if (((_b = (_a = event === null || event === void 0 ? void 0 : event.nativeEvent) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.includes('e', '-', '+', '*', '%')) || isNaN((_c = event === null || event === void 0 ? void 0 : event.nativeEvent) === null || _c === void 0 ? void 0 : _c.data))
            return;
        var max = 6;
        var numberAsString = event.target.value;
        setValue(numberAsString.substr(0, max));
        onChange(numberAsString.substr(0, max));
    }
    function handleInputBlur(event) {
        setValue(value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
        var positiveNumber = Math.abs(Number(event.target.value)).toString();
        onBlur && onBlur(positiveNumber);
    }
    var onFocus = function () {
        if (value) {
            setValue(parseInt(value.replace(',', '')));
        }
    };
    return (_jsxs(MilesInputStyle, __assign({ isQQPage: isQQPage, className: className }, { children: [_jsx("div", __assign({ className: "mileage-label" }, { children: "THIS YEAR I THINK I\u2019ll drive" })), _jsx("div", __assign({ className: "input-section LoNotSensitive" }, { children: _jsxs("div", __assign({ className: "input-container" }, { children: [_jsxs("div", __assign({ className: "input-wrapper ".concat(value.length > 5 ? 'large' : ''), ref: inputWrapperRef }, { children: [_jsxs("div", __assign({ className: "icon-wrapper" }, { children: [_jsx(IconMilesInput, { fill: theme.primaryColours.aubergine.main }), _jsx("div", { className: "input-divider" })] })), _jsx("input", { ref: inputRef, className: "input", value: value, autoComplete: "off", onChange: handleInputChange, onBlur: handleInputBlur, onFocus: onFocus, pattern: "[0-9]*", min: "0" })] })), _jsx(H3, __assign({ className: "mileage-text" }, { children: "miles" }))] })) })), showBanner && (_jsx("div", __assign({ className: "banner-wrapper LoNotSensitive" }, { children: _jsx(MessageBanner, { text: bannerText, fullWidth: false, icon: "IconThumbsUp" }) })))] })));
};
